import { UrlFilter } from '@components/modules/ProductGrid/Filter/filtering'
import { RefObject, useCallback, useEffect } from 'react'

export const useBarScroll = (
  colorsRef: RefObject<HTMLDivElement>,
  queryFilters: UrlFilter[]
): [() => void] => {
  const moveBarBack = useCallback(() => {
    const el = colorsRef.current?.querySelector(
      `div[data-color-name="${
        queryFilters.find((filter) => filter.slug === 'color')?.values[0]
      }"]`
    )
    if (el && el.classList.value.includes('disabled')) {
      colorsRef.current.querySelector('div').style.opacity = '0'
      return
    }

    if (!el) return

    const elementBoundingRect = el?.getBoundingClientRect()
    const parentLeft = colorsRef.current?.getBoundingClientRect().left || 0

    const barLeft =
      (elementBoundingRect?.left || 0) -
      parentLeft +
      (elementBoundingRect?.width || 2) / 2

    if (barLeft <= 0) {
      colorsRef.current.querySelector('div').style.opacity = '0'
    } else if (barLeft >= 0) {
      colorsRef.current.querySelector('div').style.opacity = '1'
      colorsRef.current
        .querySelector('div')
        .style.setProperty('--bar-left', `${barLeft}px`)
    }
  }, [colorsRef, queryFilters])

  const recalcBar = () => {
    // figure out which data-color we are hovering
    const el = colorsRef.current?.querySelector(`div:hover`)

    if (!el) return

    const elementBoundingRect = el?.getBoundingClientRect()
    const parentLeft = colorsRef.current?.getBoundingClientRect().left || 0

    const barLeft =
      (elementBoundingRect?.left || 0) -
      parentLeft +
      (elementBoundingRect?.width || 2) / 2

    if (barLeft <= 0) {
      colorsRef.current.querySelector('div').style.opacity = '0'
    } else if (barLeft >= 0) {
      colorsRef.current.querySelector('div').style.opacity = '1'
      colorsRef.current
        .querySelector('div')
        .style.setProperty('--bar-left', `${barLeft}px`)
    }
  }

  useEffect(() => {
    if (!colorsRef.current) return

    colorsRef.current.addEventListener('mousemove', recalcBar)
    colorsRef.current.addEventListener('mouseleave', moveBarBack)
    moveBarBack()
    return () => {
      colorsRef.current?.removeEventListener('mousemove', recalcBar)
      colorsRef.current?.removeEventListener('mouseleave', moveBarBack)
    }
  }, [colorsRef, queryFilters, moveBarBack])

  return [moveBarBack]
}
